import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import styled from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Title = styled(FormattedHTMLMessage).withConfig({
  displayName: "QuizTopbar__Title",
  componentId: "rpqs58-0"
})(["strong{font-weight:500;}"]);
const QuizTopbar = ({
  numQuestions,
  topRightComponent,
  currentQuestion
}) => /*#__PURE__*/_jsxs(Flex, {
  blockSize: "24px",
  justifyContent: "space-between",
  children: [/*#__PURE__*/_jsx(Title, {
    "data-test-id": "quiz-topbar__quiz-question-readout",
    "data-test-info-num-questions": numQuestions,
    message: "learningCenter.quiz.progress",
    options: {
      current: currentQuestion,
      total: numQuestions
    }
  }), topRightComponent]
});
export default QuizTopbar;